module.exports = __webpack_public_path__ + "static/04-94e97ab85f0d7b01ba372d60bf39c2ed.jpg";